<!--
 * @Author: DY
 * @Date: 2020-07-22 10:29:27
 * @LastEditTime: 2020-08-25 14:57:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_dev\src\views\salesTerminal\statisticalAnalysis\MaterialConsumption.vue
-->
<template>
    <div class="MaterialConsumption">
        <div class="top-wrapper">
            <div class="select-wrapper">
                <div class="select-item">
                    <div @click="startTimePicker = true">
                        <span>{{ startTimeValue }}</span>
                        <i class="iconfont iconxiala"></i>
                    </div>
                </div>
                <div
                    class="select-item"
                    @click="showPicker = true"
                >
                    <span>{{ StationName }}</span>
                    <i class="iconfont iconxiala"></i>
                </div>
                <!-- 选择场站 -->
                <van-popup
                    v-model="showPicker"
                    position="bottom"
                >
                    <van-picker
                        show-toolbar
                        :columns="columns"
                        @cancel="showPicker = false"
                        @confirm="onConfirm"
                    ></van-picker>
                </van-popup>
                <!-- 选择时间-->
                <van-popup
                    v-model="startTimePicker"
                    position="bottom"
                    :overlay="true"
                >
                    <van-datetime-picker
                        v-model="startCurrentDate"
                        type="date"
                        title="选择年月日"
                        @confirm="startConfirmData"
                        @cancel="startTimePicker = false"
                    ></van-datetime-picker>
                </van-popup>
            </div>
            <ul class="totalConsumption">
                <li>
                    <h4>{{ taskNumber.rws }}</h4>
                    <p>总任务(个)</p>
                </li>
                <li>
                    <h4>{{ taskNumber.zpd }}</h4>
                    <p>总派单(个)</p>
                </li>
                <li>
                    <h4>{{ taskNumber.scfl }}</h4>
                    <p>总生产方量(方)</p>
                </li>
                <li>
                    <h4>{{ taskNumber.sjyl }}</h4>
                    <p>总实际用量(吨)</p>
                </li>
            </ul>
        </div>
        <div class="rawMaterialTable">
            <table>
                <thead>
                    <tr>
                        <th>原材料类型</th>
                        <th>配比用量(吨)</th>
                        <th>实际用量(吨)</th>
                        <th>差值(吨)</th>
                    </tr>
                </thead>
                <tbody v-if="rawMaterial.length>0">
                    <template v-for="(item, index) in rawMaterial">
                        <tr
                            :key="index"
                            :class="[{ 'active': isActive==index }, classes(item.category_code)]"
                            @click="selectCategory(item.category_code, index)"
                        >
                            <td>{{ item.category_name }}</td>
                            <td>{{ item.theory_volume }}</td>
                            <td>{{ item.actual_value }}</td>
                            <td>{{ item.diff_value }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="charts">
            <div class="charts_header">
                <van-tabs
                    type="card"
                    color="#3495FB"
                    v-model="tabActive"
                    @click="tabSelect"
                >
                    <template v-for="(item,index) in tabData">
                        <van-tab :key="index" :title="item.name" :disabled="item.disabled"></van-tab>
                    </template>
                </van-tabs>
            </div>
            <div class="chart">
                <div id="chart1"></div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    lineBarChart,
} from '@/assets/js/charts';

export default {
    // 原材料消耗
    name: 'material-consumption',
    components: {},
    props: {},
    data() {
        return {
            // 开始时间text
            startTimeValue: '',
            // 时间弹出层
            startTimePicker: false,
            // 开始时间默认日期
            startCurrentDate: new Date(),
            // 选中场站名称
            StationName: '',
            // 选中场站id
            StationId: '',
            // 场站数据集
            columns: [],
            // 场站弹出层状态
            showPicker: false,
            // 场站初始数据
            StationData: [
                {
                    station_id: '',
                    station_name: '全部',
                },
            ],
            // 任务数
            taskNumber: {
                // 总任务
                rws: 0,
                // 总派单数
                zpd: 0,
                // 生产方量（方）
                scfl: 0,
                // 实际用量（吨）
                sjyl: 0,
            },
            // 原材料列表数据
            rawMaterial: [],
            // 原材料列表选中下标
            isActive: 0,
            // tab选项
            tabData: [{
                name: '按场站',
                disabled: false,
            }, {
                name: '按标号',
                disabled: false,
            }, {
                name: '按分类',
                disabled: false,
            }, {
                name: '近7天趋势',
                disabled: false,
            }],
            // tab默认值
            tabActive: 0,
            // 原材料类型编码
            categoryCode: '',
        };
    },
    created() {
        this.startTimeValue = this.formatDate(this.startCurrentDate);
        // 拉取场站数据
        // this.getStationList();
    },
    computed: {},
    watch: {
        startTimeValue(newVal) {
            if (newVal !== '') {
                if (this.StationData.length < 2) {
                    // 获取场站
                    this.getStationList();
                } else {
                    this.init();
                }
            }
        },
        StationId(newVal) {
            if (newVal !== '') {
                this.tabData[0].name = '按场站';
            } else {
                this.tabData[0].name = '按生产线';
            }
            this.init();
        },
        categoryCode() {
            this.tabSelect();
        },
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 获取企业下所有场站
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds.length > 0) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        station_name: stationNames[index],
                    };
                });
                this.StationData.push(...stationList);
                this.columns = this.StationData.map(item => item.station_name);
                this.StationName = this.columns[0];
                this.StationId = this.StationData[0].station_id;
                this.init();
            }
        },
        // 页面初始化
        init() {
            // 获取头部任务数数据
            this.getTaskNumberData();
            // 获取原材料列表数据
            this.getRawMaterialData();
            this.tabSelect();
        },
        // 获取头部任务数数据
        getTaskNumberData() {
            this.$axios
                .get(`/interfaceApi/report/yclxh/tjs?station_id=${this.StationId}&datetime=${this.startTimeValue}`)
                .then(res => {
                    this.taskNumber = res;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 获取原材料列表数据
        getRawMaterialData() {
            this.$toast.loading();
            this.$axios
                .get(`/interfaceApi/report/yclxh/tjlb/lx?station_id=${this.StationId}&datetime=${this.startTimeValue}`)
                .then(res => {
                    this.rawMaterial = res;
                    this.categoryCode = res[0].category_code;
                    this.$forceUpdate();
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                }).finally(() => {
                    this.$toast.clear();
                });
        },
        // 列表数据根据类型匹配类名
        classes(type) {
            let newClass = '';
            if (type.indexOf('202') !== -1) {
                newClass = 'trColor1';
            } else if (type.indexOf('203') !== -1) {
                newClass = 'trColor2';
            } else if (type.indexOf('204') !== -1) {
                newClass = 'trColor3';
            } else if (type.indexOf('205') !== -1) {
                newClass = 'trColor4';
            } else if (type.indexOf('208') !== -1) {
                newClass = 'trColor5';
            } else {
                newClass = 'trColor6';
            }
            return newClass;
        },
        // tab切换
        tabSelect() {
            if (this.tabActive === 0) {
                if (this.StationId === '') {
                    // 原材料消耗——按场站
                    this.consume_Station();
                } else {
                    // 原材料消耗——按生产线
                    this.consume_ProductionLine();
                }
            } else if (this.tabActive === 1) {
                // 原材料消耗——按标号
                this.consume_Grade();
            } else if (this.tabActive === 2) {
                // 原材料消耗——按分类
                this.consume_Classification();
            } else if (this.tabActive === 3) {
                // 原材料消耗——近七天
                this.consume_Week();
            }
        },
        // 选择原材料
        selectCategory(code, index) {
            this.categoryCode = code;
            this.isActive = index;
        },
        // 格式化折线柱图数据
        chartsData(data) {
            const chartData = {
                xdata: [],
                legendData: ['配比用量', '实际用量', '生产方量'],
                grid: ['40', '50', '40', '50'],
                yAxisName: ['(吨)', '(方)'],
                ydata: [
                    {
                        name: '配比用量',
                        type: 'bar',
                        color: ['#71C6B0', '#4EA496'],
                        data: [],
                    }, {
                        name: '实际用量',
                        type: 'bar',
                        color: ['#F2E341', '#DCC129'],
                        data: [],
                    }, {
                        name: '生产方量',
                        type: 'line',
                        color: ['#FA8436'],
                        data: [],
                    },
                ],
            };
            data.forEach(item => {
                chartData.xdata.push(item.name);
                chartData.ydata[0].data.push(item.theory_volume);
                chartData.ydata[1].data.push(item.actual_value);
                chartData.ydata[2].data.push(item.product_value);
            });
            return chartData;
        },
        // 原材料消耗——按场站
        consume_Station() {
            this.$axios
                .get(`/interfaceApi/report/yclxh/tjlb/cz?datetime=${this.startTimeValue}&category_code=${this.categoryCode}`)
                .then(res => {
                    lineBarChart('chart1', this.chartsData(res));
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 原材料消耗——按生产线
        consume_ProductionLine() {
            this.$axios
                // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/yclxh/tjlb/scx?station_id=${this.StationId}&datetime=${this.startTimeValue}&category_code=${this.categoryCode}`)
                .then(res => {
                    lineBarChart('chart1', this.chartsData(res));
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 原材料消耗——按标号
        consume_Grade() {
            this.$axios
                // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/yclxh/tjlb/bh?station_id=${this.StationId}&datetime=${this.startTimeValue}&category_code=${this.categoryCode}`)
                .then(res => {
                    lineBarChart('chart1', this.chartsData(res));
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 原材料消耗——按分类
        consume_Classification() {
            this.$axios
                // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/yclxh/tjlb/zfl?station_id=${this.StationId}&datetime=${this.startTimeValue}&category_code=${this.categoryCode}`)
                .then(res => {
                    lineBarChart('chart1', this.chartsData(res));
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 原材料消耗——近七天
        consume_Week() {
            this.$axios
                // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/yclxh/tjlb/week?station_id=${this.StationId}&datetime=${this.startTimeValue}&category_code=${this.categoryCode}`)
                .then(res => {
                    lineBarChart('chart1', this.chartsData(res));
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 确认选择场站
        onConfirm(val, index) {
            this.showPicker = false;
            this.StationName = this.StationData[index].station_name;
            this.StationId = this.StationData[index].station_id;
        },
        // 确认选择时间
        startConfirmData(val) {
            this.startTimeValue = this.formatDate(val);
            this.startTimePicker = false;
        },
        // 时间格式处理
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },

    },
};
</script>
<style lang="stylus">
.MaterialConsumption
    height 100%
    overflow scroll
    -webkit-overflow-scrolling touch
    .top-wrapper
        padding 15rpx
        padding-bottom 0
        .select-wrapper
            height 45rpx
            box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
            border-radius 8px
            display flex
            background #ffffff
            .select-item
                flex 1
                text-align center
                span
                    font-size 14rpx
                    font-weight 400
                    line-height 45rpx
                i
                    color #979EA7
                &:last-child
                    position relative
                    &:before
                        content ''
                        height 20rpx
                        position absolute
                        left 0
                        top 50%
                        margin-top -10rpx
                        border-left 3rpx solid #D7D7D7
                    span
                        color #3495FB
                        padding-left 20rpx
                &:first-child
                    display flex
                    div
                        flex 1
                    p
                        line-height 45rpx
                        color #979EA7
                        font-weight 600
        .totalConsumption
            display flex
            li
                flex 1
                text-align center
                margin 10rpx 0
                p
                    font-size 10rpx
                    color #979EA7
                h4
                    font-size 18rpx
                    line-height 30rpx
                    color #FA8436
                &:nth-of-type(1)
                    h4
                        color #5588F1
                &:nth-of-type(2)
                    h4
                        color #FA8436
                &:nth-of-type(3)
                    h4
                        color #21BDCC
                &:nth-of-type(4)
                    h4
                        color #FFB729
    .rawMaterialTable
        border-bottom 15rpx solid #F0F0F0
        padding 0 15rpx 15rpx 15rpx
        table
            width 100%
        td,th
            font-size 14rpx
            line-height 40rpx
            text-align center
        th
            background:rgba(85,136,241,0.1);
            color #333333
            font-weight 400
        tbody
            tr
                &.trColor1
                    td
                        background rgba(85, 136, 241, 0.06)
                        color #5588F1
                &.trColor2
                    td
                        background rgba(235, 101, 111, 0.06)
                        color #EB656F
                &.trColor3
                    td
                        background rgba(241, 176, 0, 0.06)
                        color #F1B000
                &.trColor4
                    td
                        background rgba(85, 136, 241, 0.06)
                        color #5588F1
                &.trColor5
                    td
                        background rgba(33, 189, 204, 0.06)
                        color #21BDCC
                &.trColor6
                    td
                        background rgba(12, 168, 235, 0.06)
                        color #0CA8EB
                &.active
                    box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                    td
                        background #8B6BEE
                        color #FFFFFF
    .charts
        padding 10rpx
        .charts_header
            margin 12rpx 30rpx
            .van-tabs__nav
                margin 0
        .chart
            height 240rpx
            margin-bottom 20rpx
            >div
                height 100%
</style>
